import { render, staticRenderFns } from "./RecordDetail.vue?vue&type=template&id=7404f45e&scoped=true&"
import script from "./RecordDetail.vue?vue&type=script&lang=js&"
export * from "./RecordDetail.vue?vue&type=script&lang=js&"
import style0 from "./RecordDetail.vue?vue&type=style&index=0&id=7404f45e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7404f45e",
  null
  
)

component.options.__file = "RecordDetail.vue"
export default component.exports